import React from 'react';

export class Navbar extends React.Component{

    render(){
        return(
            <div className="NavBar" >
                <h1 style={{color:'white'}}>Mymap Search</h1>
            </div>
        )
    }
}